import { render, staticRenderFns } from "./AsideImage.vue?vue&type=template&id=724445a2&scoped=true&lang=pug"
import script from "./AsideImage.vue?vue&type=script&lang=js"
export * from "./AsideImage.vue?vue&type=script&lang=js"
import style0 from "./AsideImage.styl?vue&type=style&index=0&id=724445a2&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724445a2",
  null
  
)

export default component.exports